
import Toast from '@/components/toast/index';
import { Indicator } from 'mint-ui';
import Native from '@/utils/nativeProxy/index';
import BrowserCallNative from '@/utils/nativeProxy/BrowserCallNative';
import env from './env';

// platformType平台种类，上传接口必填---备注: 1是安卓 2是ios 3web 4 微信小程序 5 支付宝小程序
export const PLATFORM_TYPE = {
  APP_ANDROID: '1',
  APP_IOS: '2',
  H5: '3',
  WX_MP: '4',
  ALI_MP: '5',
};

export default {
  /**
   * 调用时候打开拍照功能,返回一个promise值李装的是url
   * @returns {*|Promise}
   */
  uploadImage(type, showAlbum) {
    return new Promise((resolve, reject) => {
      const newCallNative = env.isHarmony ? BrowserCallNative : Native;
      newCallNative.chooseImageAndUploadImage({
        // type,
        showAlbum,
        beforeUpload() {
          Indicator.open({
            text: '图片上传中...',
          });
        },
        afterUpload() {
          Indicator.close();
        },
      }).then((url) => { resolve({ url }); })
        .catch((e) => {
          // eslint-disable-next-line no-console
          Toast.show('图片上传失败,请重试').catch((v) => console.log(v));
          reject(e);
        });
    });
  },

  imgCompress(imgBase64, scale, filetype) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = imgBase64;
      image.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          const canvasWidth = image.width * scale;
          const canvasHeight = image.height * scale;
          canvas.width = canvasWidth;
          canvas.height = canvasHeight;
          // eslint-disable-next-line max-len
          (context).drawImage(image, 0, 0, image.width, image.height, 0, 0, canvasWidth, canvasHeight);
          resolve(canvas.toDataURL(filetype || 'image/jpeg'));
        } catch (error) {
          reject(error);
        }
      };
    });
  },
};
